<template>
  <div class="w__skeleton" :style="{background: bgColor, height, width}"></div>
</template>

<script>
  export default{
    name: 'WSkeleton',
    props: {
      proportion: {
        type: Number,
        default: 1
      }, // h : w
      bgColor: {
        type: String,
        default: '#b4bccc'
      },
      width: {
        type: String,
        default: '100%'
      },
      heights: {
        type: [String, Boolean],
        default: false
      }
    },
    data () {
      return {
        height: this.heights || `${this.proportion * 100}%`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .w__skeleton {
    width: 100%;
    top: 0;
    left: 0;
    position: absolute;
    animation: w-opacity 2s infinite linear;
  }
  @keyframes w-opacity {
    0% {
      opacity: 1;
    }

    10%,90% {
      opacity: .9;
    }

    20%,80% {
      opacity: .8;
    }

    30%,70% {
      opacity: .7;
    }

    40%,60% {
      opacity: .6;
    }

    50% {
      opacity: .5;
    }

    100% {
      opacity: .95;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components-base/components-custom/skeleton/skeleton.vue